<template>
  <div v-if="visible" class="dialog-overlay" @click.self="handleOverlayClick">
    <div class="dialog-box">
      <div v-if="title" class="dialog-title">{{ title }}</div>
      <div class="dialog-message">{{ message }}</div>
      <div class="dialog-actions">
        <button v-if="showCancel" class="dialog-btn dialog-btn--cancel" @click="handleCancel">{{ cancelText }}</button>
        <button class="dialog-btn dialog-btn--confirm" @click="handleConfirm">{{ confirmText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
// 原生 confirm()/alert() 在 iOS WKWebView（Safari/微信内置浏览器等）下有已知的兼容性问题，
// 部分场景会被静默拦截或返回值不符合预期，导致依赖其返回值的业务逻辑（如“确认取消/退款”）在 iOS 上完全没有反应。
// 用这个组件 + $confirm/$alert 挂载方法统一替代，避免跨端不一致。
export default {
  name: 'Dialog',
  data() {
    return {
      visible: false,
      title: '',
      message: '',
      confirmText: '确定',
      cancelText: '取消',
      showCancel: true,
      resolvePromise: null
    }
  },
  methods: {
    open(options) {
      this.title = options.title || ''
      this.message = options.message || ''
      this.confirmText = options.confirmText || '确定'
      this.cancelText = options.cancelText || '取消'
      this.showCancel = options.showCancel !== false
      this.visible = true
      return new Promise(resolve => {
        this.resolvePromise = resolve
      })
    },
    handleConfirm() {
      this.visible = false
      if (this.resolvePromise) this.resolvePromise(true)
    },
    handleCancel() {
      this.visible = false
      if (this.resolvePromise) this.resolvePromise(false)
    },
    handleOverlayClick() {
      if (this.showCancel) this.handleCancel()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.dialog-box {
  width: 80%;
  max-width: 300px;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-sizing: border-box;
}

.dialog-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
  text-align: center;
}

.dialog-message {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  text-align: center;
  white-space: pre-wrap;
}

.dialog-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.dialog-btn {
  flex: 1;
  padding: 10px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  &:active { opacity: 0.8; }
}

.dialog-btn--cancel { background: #f3f4f6; color: #374151; }
.dialog-btn--confirm { background: linear-gradient(90deg, #ffa43a 0%, #ff720d 100%); color: #fff; }
</style>
